export const STORAGE_KEYS = {
  ID_TOKEN: 'idToken',
  X_VARO_SESSION: 'xVaroSession',
  REFRESH_TOKEN: 'refreshToken',
  DEVICE_INFO_ID: 'deviceInfoId',
  CAN_ASK_LOCATION_PERMISSION: 'canAskLocationPermission',
  ANONYMOUS_ID: 'anonymousId',
  PREVIOUS_PATH: 'previous_path',
  CURRENT_PATH: 'current_path',
  PENDING_DEEPLINK: 'pendingDeeplink',
};
